/*
 * Dependencies:
 * - jquery.slideshow.js
 * - jquery.fader.js
 * - jquery.fillorfit.js
 */

define('components/factory/views/ViewerView', [
    'components/factory/templates/viewerview'
], function(tpl) {

    var ViewerView = Mazarine.View.extend({

        events: {
            "click .js-maz-swiper-control": "onSwiperControlClick",
            "click .maz-viewer-slideshow-wrapper .slide": "onThumbsSwiperSlideClick"
        },

        template: tpl,

        className: "maz-viewer-view",

        /*
         * This is an override
         * It add the imagesCount just before rendering the view
         */
        getRenderDatas: function(){
            var obj = this.model.toJSON();
            obj.imagesCount = this.model.get('images').length;
            return obj;
        },

        /*
         * Initialize the fader or the slideshow according to the conf
         * Also initialize the thumbs slideshow if activated
         */
        afterRender: function() {
            this.$el.addClass('maz-viewer-skin-' + this.model.get('skinClass'));

            this.nbSwiperToLoad = (this.model.get('showThumbsSwiper')) ? 2 : 1;
            this.swipers = [];

            var method = this.model.get('swiperType') === 'fader' ? 'fadeTo' : 'slideTo';
            var alreadyLoaded = false;

            if (this.model.get('swiperType') === "fader") {

                this.$('.maz-viewer-swiper-wrapper .swiper-wrapper').fader({
                    prefix     : "maz",
                    speedOut   : 300,
                    speedIn    : 400,
                    delay      : 0,
                    shownav    : false,
                    onReady    : _.bind(this.onSwipersReady, this),
                    onFade     : _.bind(function($slides, oldIndex, newIndex) {
                        if (this.model.get('showThumbsSwiper')) {
                            this.swipers[1].slideTo(newIndex);
                        }
                        if (this.model.get('showPagination')) {
                            this.$('.maz-viewer-swiper-currentpage').text(newIndex+1);
                        }
                    }, this)
                }, _.bind(function() {
                    // On affiche le premier slide
                    this.$('.maz-viewer-swiper-wrapper .swiper-wrapper .slide:first').css('visibility', "visible");
                    if (this.model.get('showPagination')) {
                        this.$('.maz-viewer-swiper-currentpage').text('1');
                    }
                }, this));

            } else {

                this.$('.maz-viewer-swiper-wrapper .swiper-wrapper').slideshow({
                    prefix     : "maz",
                    speed      : 600,
                    shownav    : false,
                    direction  : 'ltr',
                    callsync: _.bind(function($slides, oldIndex, newIndex) {
                        if (this.model.get('showThumbsSwiper')) {
                            this.swipers[1].slideTo(newIndex, true, !alreadyLoaded);
                            alreadyLoaded = true;
                        }

                        if (this.model.get('showPagination')) {
                            this.$('.maz-viewer-swiper-currentpage').text(newIndex+1);
                        }
                    }, this)
                }, _.bind(function() {
                    this.onSwipersReady();
                }, this));

            }
            this.swipers[0] = this.$('.maz-viewer-swiper-wrapper .swiper-wrapper').data(this.model.get('swiperType'));


            if (this.model.get('showThumbsSwiper')) {

                var swiper0 = this.swipers[0];
                var swiper1 = this.$('.maz-viewer-slideshow-wrapper .swiper-wrapper');

                swiper1.slideshow({
                    prefix     : "maz",
                    speed      : 400,
                    shownav    : false,
                    direction  : 'ttb',
                    callsync: _.bind(function($slides, oldIndex, newIndex) {
                        this.swipers[0].fadeTo(newIndex);
                    }, this)
                }, _.bind(function() {
                    swiper1.nbSlides = swiper1.children('.slide').length;
                    swiper1.activeIndex = parseInt(this.model.get('currentSlide'), 10);
                    this.onSwipersReady();
                }, this));

                var swiperThumbsIsSlideshow = true;

                if (window.popinSwiperThumbsModeIsStatic) {
                    swiperThumbsIsSlideshow = false;
                }

                this.setSwiperThumbsMode(swiper0, swiper1, swiperThumbsIsSlideshow);

            }

            this.swipers[0][method](parseInt(this.model.get('currentSlide'), 10), true, false);
        },

        setSwiperThumbsMode: function(swiper0, swiper1, isSlideshow) {
            if (isSlideshow) {
                this.swipers[1] = this.$('.maz-viewer-slideshow-wrapper .swiper-wrapper').data('slideshow');
            } else {
                $('.maz-viewer-slideshow-wrapper .maz-viewer-slideshow-prev').css('display', 'none');
                $('.maz-viewer-slideshow-wrapper .maz-viewer-slideshow-next').css('display', 'none');
                this.swipers[1] = swiper1;
                swiper1.slideTo = function(newIndex, cleantimer, useanim) {
                    swiper1.children('.active').each(function(){
                        $(this).removeClass('active');
                    });
                    swiper1.activeIndex = newIndex;
                    swiper1.children().eq(newIndex).addClass('active');
                    swiper0.fadeTo(newIndex);
                };
                swiper1.fadeTo = swiper1.slideTo;
            }
        },

        onSwipeStart: function(e) {
            var $swiper = this.$('.maz-viewer-swiper-wrapper .swiper-wrapper');
            var touch = (window.navigator.msPointerEnabled) ? e.originalEvent : e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];

            $swiper.data('x', touch.pageX);

            $(document).on('touchend.viewerview MSPointerUp.viewerview', _.bind(this.onSwipeEnd, this));
        },

        onSwipeEnd: function(e) {
            var $swiper = this.$('.maz-viewer-swiper-wrapper .swiper-wrapper');
            var touch = (window.navigator.msPointerEnabled) ? e.originalEvent : e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
            var deltaX = $swiper.data('x') - touch.pageX;

            if (Math.abs(deltaX) > 80) {
                if (deltaX > 0) {
                    this.swipers[0].fadeNext();
                } else {
                    this.swipers[0].fadePrev();
                }
            }

            $(document).off('.viewerview');
        },

        onThumbsSwiperSlideClick: function(e) {
            var $slide = $(e.currentTarget);
            var slideIndex = this.$('.maz-viewer-slideshow-wrapper .slide').index($slide);

            this.swipers[1].slideTo(slideIndex);
        },

        onSwiperControlClick: function( e ) {
            var $control = $(e.currentTarget);
            var swiper = this.swipers[$control.attr('data-instance')];
            var increment = parseInt($control.attr('data-increment'), 10);
            var nbSlides = swiper.nbSlides;
            var newIndex = swiper.activeIndex + increment;

            if (newIndex > nbSlides - 1) {
                newIndex = 0;
            }
            if (newIndex < 0) {
                newIndex = nbSlides - 1;
            }

            if (swiper.fadeTo) {
                swiper.fadeTo(newIndex);
            } else {
                swiper.slideTo(newIndex);
            }
        },

        onSwipersReady: function() {
            this.nbSwiperToLoad--;

            if (this.nbSwiperToLoad === 0) {
                this.$('.maz-viewer-swiper-wrapper .swiper-wrapper').on('touchstart MSPointerDown', _.bind(this.onSwipeStart, this));
                this.$('.maz-viewer-swiper-wrapper .js-fill-parent').fillorfit(this.model.get('fillOrFitOptions'));
                if (window.popinSwiperThumbsModeIsStatic) {
                    this.$('.maz-viewer-slideshow-wrapper').addClass('maz-viewer-slideshow-wrapper_static');
                } else {
                    this.$('.maz-viewer-slideshow-wrapper .js-fill-parent').fillorfit({
                        method: 'fill',
                        verticalAlign: 'center',
                        horizontalAlign: 'center'
                    });
                }
                this.model.set('isReady', true);
            }
        }
    });

    return ViewerView;
});
